import { CheckCircle2, Loader2, RefreshCw } from "lucide-react";
import { Button } from "./ui/button";

export function AnalyticsBackfillGate({
  preparing,
  importing = false,
  error,
  onRetry,
}: {
  preparing: boolean;
  importing?: boolean;
  error: Error | null;
  onRetry: () => void;
}) {
  return (
    <section
      className="max-w-3xl py-10 sm:py-14"
      aria-labelledby="analytics-backfill-heading"
    >
      <div className="rounded-xl border border-border bg-background p-5 sm:p-7">
        <div className="flex items-center gap-2 text-xs font-medium text-emerald-700">
          <CheckCircle2 className="h-4 w-4" aria-hidden />
          Accounts connected
        </div>
        <h2
          id="analytics-backfill-heading"
          className="mt-5 text-xl font-semibold text-foreground"
        >
          We’re getting your analytics ready
        </h2>

        <div
          className="mt-7 flex items-center gap-3 text-sm text-foreground"
          aria-live="polite"
        >
          <Loader2
            className="h-4 w-4 animate-spin text-brand-ink"
            aria-hidden
          />
          <div>
            <p className="font-medium">
              {preparing
                ? "Getting started…"
                : importing
                  ? "Importing posts from the last 180 days"
                  : "Adding data from your past posts"}
            </p>
            <p className="mt-1 text-xs leading-5 text-muted-foreground">
              You can leave this page and check back later.
            </p>
          </div>
        </div>

        {error ? (
          <div
            className="mt-6 rounded-lg border border-red-200 bg-red-50 p-4"
            role="alert"
          >
            <p className="text-sm font-medium text-red-900">
              We couldn’t finish setting up analytics
            </p>
            <p className="mt-1 text-sm text-red-800">{error.message}</p>
            <Button
              variant="outline"
              size="sm"
              className="mt-3 bg-background"
              onClick={onRetry}
            >
              <RefreshCw className="mr-2 h-4 w-4" aria-hidden />
              Try again
            </Button>
          </div>
        ) : null}
      </div>
    </section>
  );
}
